import React from 'react';
import { GOOGLE_CLIENT_ID } from '../config';

const GSI_SCRIPT = 'https://accounts.google.com/gsi/client';
let scriptPromise = null;

// Load Google Identity Services once for the whole app
function loadGoogleScript() {
    if (window.google && window.google.accounts && window.google.accounts.id) {
        return Promise.resolve();
    }
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.src = GSI_SCRIPT;
            script.async = true;
            script.defer = true;
            script.onload = resolve;
            script.onerror = () => {
                scriptPromise = null;
                reject(new Error("Couldn't load Google sign-in"));
            };
            document.head.appendChild(script);
        });
    }
    return scriptPromise;
}

// Google's own "Sign in with Google" button. Calls onCredential with the ID token Google returns, or onError if
// Google's script can't load. Renders nothing when no client id is configured.
export class GoogleSignInButton extends React.Component {

    container = React.createRef();

    componentDidMount() {
        if (!GOOGLE_CLIENT_ID) {
            console.warn('Sign in with Google is hidden: REACT_APP_GOOGLE_CLIENT_ID is not set');
            return;
        }
        loadGoogleScript().then(() => {
            if (!this.container.current) {
                return;
            }
            window.google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: (response) => this.props.onCredential(response.credential)
            });
            window.google.accounts.id.renderButton(this.container.current, {
                theme: 'filled_black',
                size: 'large',
                shape: 'rectangular',
                text: this.props.text || 'signin_with',
                width: this.container.current.offsetWidth || 356
            });
        }).catch((err) => {
            if (this.props.onError) {
                this.props.onError(err);
            }
        });
    }

    render() {
        if (!GOOGLE_CLIENT_ID) {
            return null;
        }
        return <div className="google-signin" ref={this.container}></div>;
    }

}
